exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "level-teaser md-card-title-text span.md-headline{font-size:18px;line-height:20px}level-teaser .level-description{font-size:10px;line-height:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/autoprefixer-loader?{browsers:['last 2 version']}!../~/sass-loader!./components/elements/levelTeaser/levelTeaser.scss
// module id = 34
// module chunks = 0